"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidParentNamesMap = exports.validParentNamesMap = void 0;
exports.validParentNamesMap = {
    course: [],
    section: ['section', 'course'],
    content: ['section'],
    module: ['content']
};
exports.invalidParentNamesMap = {
    course: ['course', 'section', 'content', 'module'],
    section: ['content', 'module'],
    content: ['content', 'module', 'course'],
    module: ['module', 'section', 'course']
};
//# sourceMappingURL=parentNameMaps.js.map